import React from 'react';

const iconPaths = {
  truck: <path d="M3 7h11v7H3z M14 9h3l2 2v3h-5 M7 17a1.5 1.5 0 1 1 0 .01 M17 17a1.5 1.5 0 1 1 0 .01" />,
  dashboard: <path d="M4 4h7v7H4z M13 4h7v4h-7z M13 10h7v10h-7z M4 13h7v7H4z" />,
  kpi: <path d="M4 18l5-6 4 3 7-9 M4 4v16h16" />,
  map: <path d="M3 6l6-2 6 2 6-2v14l-6 2-6-2-6 2z M9 4v14 M15 6v14" />,
  package: <path d="M3 8l9-5 9 5-9 5-9-5z M3 8v8l9 5 9-5V8 M12 13v8" />,
  fuel: <path d="M7 4h8v16H7z M15 7h2l2 2v7a2 2 0 0 1-2 2h-2 M9 8h4" />,
  users: <path d="M9 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6z M3 20a6 6 0 0 1 12 0 M17 11a2.5 2.5 0 1 0 0-5 M20 20a4.5 4.5 0 0 0-4-4.45" />,
  link: <path d="M10 13a4 4 0 0 1 0-6l2-2a4 4 0 0 1 6 6l-1 1 M14 11a4 4 0 0 1 0 6l-2 2a4 4 0 1 1-6-6l1-1" />,
  activity: <path d="M4 13h4l2-5 4 10 2-5h4" />,
  settings: <path d="M12 8a4 4 0 1 0 0 8 4 4 0 0 0 0-8z M2 12h2 M20 12h2 M12 2v2 M12 20v2 M4.9 4.9l1.4 1.4 M17.7 17.7l1.4 1.4 M19.1 4.9l-1.4 1.4 M6.3 17.7l-1.4 1.4" />,
  refresh: <path d="M20 11a8 8 0 1 0 2 5 M20 4v7h-7" />,
  export: <path d="M12 3v12 M7 8l5-5 5 5 M4 15v4h16v-4" />,
  plus: <path d="M12 5v14 M5 12h14" />,
  pencil: <path d="M4 20l4-1 10-10-3-3L5 16l-1 4z M13 6l3 3" />,
  sync: <path d="M4 12a8 8 0 0 1 13-6 M20 12a8 8 0 0 1-13 6 M17 2v4h-4 M7 22v-4h4" />,
  database: <path d="M4 7c0-2 4-4 8-4s8 2 8 4-4 4-8 4-8-2-8-4z M4 7v5c0 2 4 4 8 4s8-2 8-4V7 M4 12v5c0 2 4 4 8 4s8-2 8-4v-5" />,
  tag: <path d="M3 11l8-8h8v8l-8 8-8-8z M14.5 7.5h.01" />,
  globe: <path d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20z M2 12h20 M12 2a15 15 0 0 1 0 20 M12 2a15 15 0 0 0 0 20" />,
  endpoint: <path d="M5 12h14 M15 8l4 4-4 4 M5 8a2 2 0 1 0 0 .01 M5 16a2 2 0 1 0 0 .01" />,
  lock: <path d="M6 10V8a6 6 0 1 1 12 0v2 M5 10h14v10H5z" />,
  key: <path d="M14 14a4 4 0 1 1 2.9-6.7L22 7v3h-2v2h-2v2h-2z" />,
  search: <path d="M11 18a7 7 0 1 1 0-14 7 7 0 0 1 0 14z M20 20l-4-4" />,
  check: <path d="M4 12l5 5L20 6" />,
  ban: <path d="M5 5l14 14 M19 5L5 19" />,
  trash: <path d="M4 7h16 M9 7V5h6v2 M7 7l1 13h8l1-13" />,
  login: <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4 M10 17l5-5-5-5 M3 12h12" />,
  view: <path d="M2 12s4-6 10-6 10 6 10 6-4 6-10 6-10-6-10-6z M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6z" />,
  note: <path d="M6 3h9l3 3v15H6z M15 3v3h3 M9 11h6 M9 15h6" />,
  shield: <path d="M12 3l8 3v6c0 5-3.5 8.5-8 10-4.5-1.5-8-5-8-10V6z" />,
  star: <path d="M12 3l2.8 5.6 6.2.9-4.5 4.4 1.1 6.1-5.6-2.9-5.6 2.9 1.1-6.1L3 9.5l6.2-.9z" />,
  speed: <path d="M4 16a8 8 0 1 1 16 0 M12 12l4-4" />,
  pin: <path d="M12 21s6-5.5 6-10a6 6 0 1 0-12 0c0 4.5 6 10 6 10z M12 13a2 2 0 1 0 0-4 2 2 0 0 0 0 4" />,
  money: <path d="M3 7h18v10H3z M7 12h.01 M17 12h.01 M12 12a2.5 2.5 0 1 1 0 .01" />,
  save: <path d="M5 3h12l2 2v16H5z M8 3v6h8V3 M9 19h6" />,
  menu: <path d="M4 7h16 M4 12h16 M4 17h16" />,
  close: <path d="M6 6l12 12 M18 6L6 18" />,
};

const AppIcon = ({ name, className = '', size = 16, decorative = true }) => {
  const iconName = (name || '').toLowerCase();
  const icon = iconPaths[iconName] || iconPaths.note;
  const ariaProps = decorative
    ? { 'aria-hidden': 'true' }
    : { role: 'img', 'aria-label': iconName || 'icon' };

  return (
    <svg
      className={`app-icon ${className}`.trim()}
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="none"
      stroke="currentColor"
      strokeWidth="1.9"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...ariaProps}
    >
      {icon}
    </svg>
  );
};

export default AppIcon;
